import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Ring.scss';
export default function Ring({ size = 40, color = 'black', speed = 2, stroke = 5, bgOpacity = 0, }) {
    const sizeInt = parseInt(size + '');
    const strokeInt = parseInt(stroke + '');
    const centerPoint = sizeInt / 2;
    const radius = Math.max(0, sizeInt / 2 - strokeInt / 2);
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
            '--uib-bg-opacity': bgOpacity + '',
        }, children: _jsxs("svg", { className: styles.inner, viewBox: `0 0 ${size} ${size}`, height: size, width: size, children: [_jsx("circle", { className: styles.track, cx: centerPoint, cy: centerPoint, r: radius, pathLength: "100", strokeWidth: `${stroke}px`, fill: "none" }), _jsx("circle", { className: styles.car, cx: centerPoint, cy: centerPoint, r: radius, pathLength: "100", strokeWidth: `${stroke}px`, fill: "none" })] }) }));
}
